import { Link } from '@tanstack/react-router';

import { Button } from '@/components/health-ui';
import { NotFoundState } from '@/components/not-found-state';

export function NotFoundComponent(): React.JSX.Element {
  const actions = [
    <Button key="patients" asChild>
      <Link to="/patients">Back to Patients</Link>
    </Button>,
    <Button key="dashboard" variant="outline" asChild>
      <Link to="/dashboard">Go to Dashboard</Link>
    </Button>,
  ];

  return <NotFoundState actions={actions} />;
}
